import { render } from "./GeneralValueInput.vue?vue&type=template&id=2368bf22"
import script from "./GeneralValueInput.vue?vue&type=script&lang=js"
export * from "./GeneralValueInput.vue?vue&type=script&lang=js"

import exportComponent from "/home/alejo/Development/AT/Apps/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__